<template>
  <AResult
    status="403"
    title="403"
    sub-title="Sorry, you are not authorized to access this page."
  />
</template>
